import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import FormItem from '../FormItem';
export default function FormButtons(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormItem, _extends({}, otherProps, {
    label: /*#__PURE__*/React.createElement("span", null),
    className: classNames('jmtd-form-buttons', className)
  }), children);
}
FormButtons.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
FormButtons.defaultProps = {
  children: null,
  className: ''
};